<template>
  <div class="mb-30">
    <div class="single-counter">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Ex. Misturas e pastas para a preparação de produtos de padaria..."
          aria-label
          aria-describedby="pesquisa ncm"
          v-model="pesquisa"
          @keyup.enter="pesquisar()"
        />

        <div class="input-group-prepend">
          <button class="btn btn-labeled btn-info" type="button" @click="pesquisar()">
            Pesquisar
            <div
              class="spinner-border text-white loading ml-2"
              v-if="loadingPesquisa"
              role="status"
            >
              <span class="sr-only">Aguarde...</span>
            </div>
          </button>
        </div>
      </div>

      <div class="erro" v-if="validacaoNcm">A descrição deve conter no mínimo 4 caracteres</div>
      <p class="fs-12 texto-italico mt-5 box-nota p-2 centralizar">
        <strong>NOTA LEFISC:</strong><br/>
        <span class="d-inline-block mb-1 mt-1">Consulta na ferramenta de Monitoramento de NCM relativo ao ICMS tem como objetivo informar a alíquota interna do produto no Estado.</span>
        <span class="d-inline-block mb-1">Os benefícios fiscais como isenção, redução de base de cálculo, não-incidência ou, ainda, operações amparadas por diferimento ou suspensão, não estão contempladas, devendo ser consultada a legislação de cada Estado.</span>
        <span>Contudo, informamos que os benefícios fiscais da isenção, base de cálculo reduzida e da não-incidência estão em processo de elaboração pela equipe LEFISC e  serão em breve implantadas nesta ferramenta.</span>
      </p>
      <transition name="exibir">
        <div
          class="mt-5 scrollable"
          v-if="resultadoBuscas != 'Nenhum resultado encontrado' && resultadoBuscas"
        >
          <h5>Resultado:</h5>

          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">NCM</th>
                <th scope="col">Descrição</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in resultadoBuscas" :key="index">
              <tr class="cursor-pointer" @click="irParaHistorico(item.ncm)">
                <th scope="row">{{ item.ncm }}</th>
                <td>{{ item.descricao | truncar}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </transition>
    </div>
    <nao-encontrada />
  </div>
</template>

<script>
import { setTimeout } from "timers";
import modalNaoEncontrada from "../../shared/modalNaoEncontrada";
import serviceBuscaDescricao from "../../services/ServiceBuscaDescricao";
export default {
  props: {
    selecionado: ""
  },
  components: {
    "nao-encontrada": modalNaoEncontrada
  },
  data() {
    return {
      pesquisa: "",
      validacaoNcm: false,
      loadingPesquisa: false,
      mensagemErro: "",
      resultadoBuscas: "",
      resultado: "",
      campos: ["ncm", "descricao"],
      estado: ""
    };
  },

  filters: {
    truncar: string => {
      if (string.length > 120) {
        return string.substring(0, 120) + "...";
      } else {
        return string || "";
      }
    }
  },

  methods: {
    emitirAlteracoes(valor) {
      this.$emit("alterado", valor);
    },

    irParaHistorico(ncm) {
      this.$router.push({ path: `/monitoramentoncm/historico/${ncm}` });
    },

    async pesquisar() {
      if (this.pesquisa.length > 3) {
        this.validacaoNcm = false;
        this.loadingPesquisa = true;
        await serviceBuscaDescricao
          .getResultados(this.pesquisa)
          .then(
            res => {
              this.loadingPesquisa = false;
              if (res.data == "NCM não encontrada!") {
                this.$bvModal.show("ncmNaoEncontrada");
                this.mensagemErro = res;
              } else if (res.status != 400) {
                this.resultadoBuscas = res;

                /* res.forEach(elemento => {
                let objeto = {
                  isActive: true,
                  ncm: elemento.ncm,
                  descricao: elemento.descricao
                };
                this.resultadoBuscas.push(objeto);
                console.log(objeto);
              }); */
              } else if (res.status == 400) {
                this.$bvModal.show("ncmNaoEncontrada");
              }
            },
            err => {
              this.loadingPesquisa = false;
              this.resultadoBuscas = "";
              console.error("nao foi possivel obter dados do servidor");
            }
          )
          .catch(erro => {
            if (erro) this.resultadoBuscas = "Nenhum resultado encontrado";
          });
      } else {
        this.validacaoNcm = true;
        this.resultadoBuscas = "";
      }
    }
  }
};
</script>

<style scoped>
.single-counter {
  min-height: 130px;
  max-height: auto;
  height: auto;
}
.erro {
  color: red;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.fs-12 {
  font-size: 12px;
}

.texto-italico {
  font-style: italic;
  line-height: 15px;
}

.posicao-relativa {
  position: relative;
}

.preresultado:hover {
  color: gray;
  cursor: pointer;
}

.exibir-enter,
.exibir-leave-to {
  min-height: 0;
  max-height: 0;
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  min-height: 1;
  max-height: 700px;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.4s;
}

.cursor-pointer {
  cursor: pointer;
}
</style>